import { TargetSelector, combinedSettingsSelector, createShallowEqualSelector } from "@client/selectors";

export const makeStyleSelector = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    "sepBorder",
    { name: "sepCustomColor", prop: "sepCustomColor", type: "color" },
    "sepHeight"
  ]);

  return createShallowEqualSelector(
    [settingsSelector],
    (settings): React.CSSProperties => ({
      borderTop: `${settings.sepHeight} ${settings.sepBorder === "emt-solid" ? "solid" : settings.sepBorder} ${
        settings.sepCustomColor ?? "var(--color)"
      }`
    })
  );
};
